<mat-card class="overview-card table-card total-table-border">
	<mat-card-title>
		<mat-list class="overview-card-header">
			<mat-list-item>
				<h5 class="mt-0">
					Pay Scale
					<span *ngIf="isAddRecord" class="secondary-text"
						>- Click any cell in an editable column to start editing</span
					>
				</h5>
			</mat-list-item>
		</mat-list>
	</mat-card-title>
	<div class="pay-scale-table">
		<ag-grid-angular
			class="ag-theme-balham"
			style="width: 100%"
			[style.height]="
				calculatedPayScaleRates.length < 35 ? 70 + calculatedPayScaleRates.length * 30 + 'px' : '350px'
			"
			[columnDefs]="payScalesColumnDefs"
			[gridOptions]="gridOptions"
			[rowData]="calculatedPayScaleRates"
			[singleClickEdit]="true"
			[stopEditingWhenGridLosesFocus]="true"
			(cellValueChanged)="onCellValueChanged($event)"
			(gridReady)="onGridReady($event)"
		>
		</ag-grid-angular>
	</div>
</mat-card>
